import { render, staticRenderFns } from "./DashboardCommon.vue?vue&type=template&id=63cabad1&scoped=true&"
import script from "./DashboardCommon.vue?vue&type=script&lang=ts&"
export * from "./DashboardCommon.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardCommon.vue?vue&type=style&index=0&id=63cabad1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cabad1",
  null
  
)

export default component.exports